import React, { Suspense } from "react";
import styled from "styled-components";
import LoadingIndicator from "../common/LoadingIndicator";
import { Outlet } from "react-router";

const Layout: React.FC = () => {
  return (
    <StyledLayout>
      <Suspense fallback={<LoadingIndicator show />}>
        <Outlet />
      </Suspense>
    </StyledLayout>
  );
};

export default Layout;

const StyledLayout = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
`;
